module.exports = __webpack_public_path__ + "img/blockchain.f73a2a26.svg";